'use client'
import React, { useEffect, useState, createContext, ReactNode } from 'react'
import { registerCareContextUpdater } from '@/lib/careContextSync'
import { CareType } from '@/types/interfaces/care'

type CareContextType = {
    care: CareType | null
    updateCare: (newCare: CareType | null) => void
}

export const CareContext = createContext<CareContextType>({
    care: null,
    updateCare: () => {},
})

type CareProviderProps = {
    children: ReactNode
}

export const CareProvider = ({ children }: CareProviderProps) => {
    const [care, setCare] = useState<CareType | null>(null)

    useEffect(() => {
        registerCareContextUpdater(setCare)
        return () => registerCareContextUpdater(null)
    }, [])

    return <CareContext.Provider value={{ care, updateCare: setCare }}>{children}</CareContext.Provider>
}
